"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAllTags = void 0;
const tslib_1 = require("tslib");
const helpers_1 = require("../helpers");
const constants_1 = require("../constants");
const axiosUtil_1 = require("../utils/axiosUtil");
const constantsV2_1 = require("../constantsV2");
/**
 *  Returns the tags available based on the filter provided
 */
const getAllTags = options => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
  const {
    page = 1,
    limit = 10,
    order = constantsV2_1.default.FILTER.CHANNEL_LIST.ORDER.DESCENDING,
    filter = constantsV2_1.default.FILTER.TAGS.PUSH,
    env = constants_1.default.ENV.PROD
  } = options || {};
  const API_BASE_URL = (0, helpers_1.getAPIBaseUrls)(env);
  const apiEndpoint = "".concat(API_BASE_URL, "/v1/channels");
  const queryObj = {
    page,
    limit,
    order,
    filter
  };
  const requestUrl = "".concat(apiEndpoint, "/tags/all?").concat((0, helpers_1.getQueryParams)(queryObj));
  return yield (0, axiosUtil_1.axiosGet)(requestUrl).then(response => {
    var _a;
    return (_a = response.data) === null || _a === void 0 ? void 0 : _a.tags;
  }).catch(err => {
    console.error("[EPNS-SDK] - API ".concat(requestUrl, ": "), err);
  });
});
exports.getAllTags = getAllTags;
//# sourceMappingURL=getAllTags.js.map